import { useState, useEffect } from 'react';
import { Link, useLocation } from 'wouter';
import { ROUTES } from '../../routes/Routes';
import logo from "../../assets/icons/app_logo.png";
import '../../assets/css/components/Navbar.css';

export function Navbar() {
  const [location] = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    console.log("location", location);
  }, [location]);

  return (
    <header className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container navbar-container">
        <Link href={ROUTES.HOME.path} className="navbar-logo">
          <img className="logo" alt='logo' src={logo} />
          <span className="navbar-logo-primary">Logicraft</span> <span className="navbar-logo-secondary">Infotech</span>
        </Link>

        <button
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`fa-solid ${mobileMenuOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
        </button>

        <nav className={`navbar-nav ${mobileMenuOpen ? 'open' : ''}`}>
          <ul className="nav-list">
            {Object.values(ROUTES).map((route) => (
              <li key={route.path} className="nav-item">
                <Link
                  href={route.path}
                  className={`nav-link ${location === route.path ? 'active' : ''}`}
                >
                  {route.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="nav-cta-wrapper">
            <Link href={ROUTES.CONTACT.path} className="nav-cta">
              Get a Quote
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
}